"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseApiService_1 = require("../apiServices/baseApiService/BaseApiService");
var Url_1 = require("./Url");
var AbilityService_1 = require("../apiServices/auth/AbilityService");
var Assets = /** @class */ (function () {
    function Assets() {
    }
    Assets.prototype.GetEdges = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BaseApiService_1.BaseApiService.get(Url_1.url.DeviceUrl)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.GetDevicesConnectivityType = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BaseApiService_1.BaseApiService.get(Url_1.url.GetDevicesConnectivityType)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.systemStructureChildObjectsDetails = function (objectId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.systemStructureChildObjects + "?objectId=" + objectId + "&systemStructureModel=" + modelId;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.systemStructureChildObjects = function (objectId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.systemStructureChildObjectsWithOutAmDetailsUrl + "?objectId=" + objectId + "&systemStructureModel=" + modelId;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.GetStructures = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BaseApiService_1.BaseApiService.get(Url_1.url.StructureUrl)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.systemStructureObjectsDetails = function (systemId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.SystemStructureObjectsUrl + "?systemId=" + systemId + "&systemStructureModel=" + modelId;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.systemStructureObjects = function (systemId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.SystemStructureObjectsWithOutAmDetailsUrl + "?systemId=" + systemId + "&systemStructureModel=" + modelId;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.GetObjectByEdge = function (edgeObjectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.DeviceObjectUrl + "?edgeId=" + edgeObjectId;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.getObjectByEdgePaging = function (edgeId, count, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.DeviceObjectUrlPaging + "?edgeId=" + edgeId + "&count=" + count + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.QuerySystemStructureObjects = function (modelId, query, all, amInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.QueryObjects + "?model=" + modelId + "&query=" + query + "&all=" + all + "&amInfo=" + amInfo;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.GetSystems = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BaseApiService_1.BaseApiService.get(Url_1.url.LoadSystemsUrl)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.GetVariables = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.modelVariablesUrl + "?objectId=" + objectId;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.QueryStructureObjectsPaging = function (modelId, query, all, amInfo, count, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.QueryObjectsPaging + "?" + "model=" + modelId + "&query=" + query + "&all=" + all + "&amInfo=" + amInfo +
                            "&count=" + count + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.getSystemStructureModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.systemStructureModels;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.getConnectDetailsFromIdentityModels = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.connectDetailsFromIdentityModels;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.getSystemsBasedOnConnectModel = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.systemsBasedOnConnectModel + "/" + modelId;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.getChildObjects = function (query, groupBy, nameLookupModel, groupingIdentifier, all, aminfo, count, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.QueryHierarchicalObjectsPaging + "?query=" + query + "&groupBy=" + groupBy + "&nameLookupModel=" + nameLookupModel + "&groupingIdentifier=" + groupingIdentifier + "&all=" + all + "&aminfo=" + aminfo + "&count=" + count + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.getChildObjectsST = function (query, groupBy, nameLookupModel, groupingIdentifier, all, aminfo, count, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.QueryHierarchicalObjectsPagingST + "?query=" + query + "&groupBy=" + groupBy + "&nameLookupModel=" + nameLookupModel + "&groupingIdentifier=" + groupingIdentifier + "&all=" + all + "&aminfo=" + aminfo + "&count=" + count + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.filterObjects = function (query, groupBy, nameLookupModel, groupingIdentifier, all, amInfo, filterOptions, count, pageNumber, pageSize) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filter, url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = {
                            "query": query,
                            "groupBy": groupBy,
                            "nameLookupModel": nameLookupModel,
                            "groupingIdentifier": groupingIdentifier,
                            "all": all,
                            "amInfo": amInfo,
                            "options": filterOptions
                        };
                        url = Url_1.url.FilterObjects + "?count=" + count + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, filter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.filterSystemStructureObjects = function (model, count, pageNumber, pageSize, query, all, amInfo, filterOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filter, url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = {
                            "query": query,
                            "all": all,
                            "amInfo": amInfo,
                            "options": filterOptions
                        };
                        url = Url_1.url.FilterSystemStructureObjects + "?model=" + model + "&count=" + count + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, filter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.filterEdgeObjects = function (edgeId, count, pageNumber, pageSize, filterOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filter, url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = {
                            "options": filterOptions
                        };
                        url = Url_1.url.FilterEdgeObjects + "?edgeId=" + edgeId + "&count=" + count + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, filter)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.getAssetTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = Url_1.url.AssetTypes + "?nameLookupModel=&tenantId=" + AbilityService_1.AbilityService.tenantId;
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Assets.prototype.getAssetModelTypes = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = Url_1.url.AssetModelTypes + "?objectId=" + objectId + "&tenantId=" + AbilityService_1.AbilityService.tenantId;
                return [2 /*return*/, BaseApiService_1.BaseApiService.get(url)];
            });
        });
    };
    Assets.prototype.createStrucutreModel = function (name, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var createStructure, url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        createStructure = {
                            "name": name,
                            "modelId": modelId,
                            "tenantId": AbilityService_1.AbilityService.tenantId
                        };
                        url = "" + Url_1.url.CreateStrucutreModelUrl;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, createStructure)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.editStrucutreModel = function (name, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var editStructure, url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        editStructure = {
                            "name": name,
                            "modelId": modelId,
                            "tenantId": AbilityService_1.AbilityService.tenantId
                        };
                        url = "" + Url_1.url.EditStrucutreModelUrl;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.put(url, editStructure)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.deleteStrucutreModel = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.DeleteStrucutreModelUrl + "?modelId=" + modelId + "&tenantId=" + AbilityService_1.AbilityService.tenantId;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.delete(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.cloneStrucutreModel = function (clonedStrucutreName, clonedStrucutreModelId, originSourceId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var cloneStructure, url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cloneStructure = {
                            "clonedStrucutreName": clonedStrucutreName,
                            "clonedStrucutreModelId": clonedStrucutreModelId,
                            "originSourceId": originSourceId,
                            "tenantId": AbilityService_1.AbilityService.tenantId
                        };
                        url = "" + Url_1.url.CloneStrucutreModelUrl;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, cloneStructure)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.getSystemStructureModelNamesAndIdsForTenantExt = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.SystemStructureModelsWithTenantIdUrl;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.getSystemStructureModelNamesAndIdsForTenantExt2 = function (systemId, groupingIdentifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.SystemStructureModelsAndObjectsWithTenantIdUrl + "?systemId=" + systemId + "&groupingIdentifier=" + groupingIdentifier;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.getSystemStructureModelsForSpecificTenant = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + Url_1.url.SystemStructureModelsForSpecificTenant;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.getSystemStructureModelNamesAndIds = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = "" + Url_1.url.SystemStructureModelsAndObjectsWithTenantIdUrl;
                return [2 /*return*/];
            });
        });
    };
    Assets.prototype.addStrucutreNode = function (parentObjectId, objectId, structureModelId, name, originStructureModelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var addStrucutreNode, url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addStrucutreNode = {
                            "parentObjectId": parentObjectId,
                            "objectId": objectId,
                            "structureModelId": structureModelId,
                            "name": name,
                            "originStructureModelId": originStructureModelId,
                            "tenantId": AbilityService_1.AbilityService.tenantId
                        };
                        url = "" + Url_1.url.AddStrucutreNode;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.post(url, addStrucutreNode)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.editStrucutreNodeName = function (newName, objectId, structureModelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var editStructure, url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        editStructure = {
                            "newName": newName,
                            "objectId": objectId,
                            "structureModelId": structureModelId
                        };
                        url = "" + Url_1.url.EditStrucutreNodeName;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.put(url, editStructure)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    Assets.prototype.deleteStrucutreNode = function (modelId, objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = Url_1.url.DeleteStrucutreNode + "?modelId=" + modelId + "&objectId=" + objectId;
                        return [4 /*yield*/, BaseApiService_1.BaseApiService.delete(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return Assets;
}());
exports.Assets = Assets;
//# sourceMappingURL=Assets.js.map